
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function CFNPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-[#b8144a] to-[#d91e5b] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">Christ Family Network</h1>
          <p className="text-xl max-w-4xl mx-auto">
            Small group teaching and prayer centers planted across cities, towns, and nations, 
            uniting believers in the doctrine of Christ
          </p>
        </div>
      </section>

      {/* What is CFN */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">What is Christ Family Network?</h2>
              <div className="prose prose-lg text-gray-700">
                <p className="text-xl leading-relaxed mb-6">
                  Christ Family Network (CFN) is the foundational arm of Peter Akinnubi Apostolic Mandate, 
                  establishing small group teaching and prayer centers in cities, towns, and nations worldwide.
                </p>
                <p className="text-lg leading-relaxed mb-6">
                  CFN centers serve as local hubs where believers gather for apostolic teaching, fellowship, 
                  prayer, and discipleship. Each center operates under the spiritual oversight of PAAM, 
                  ensuring doctrinal unity and apostolic order.
                </p>
                <p className="text-lg leading-relaxed">
                  Through CFN, we are building a global family of Spirit-filled believers unified in the 
                  doctrine of Christ, bringing the Gospel from every nation to every nation.
                </p>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Small%20group%20of%20diverse%20believers%20gathered%20in%20prayer%20and%20Bible%20study%2C%20intimate%20fellowship%20setting%20with%20warm%20lighting%2C%20people%20of%20different%20ages%20and%20backgrounds%20united%20in%20worship%2C%20Christ-centered%20community%20meeting%20in%20simple%20home%20setting%20with%20Bibles%20open%20and%20hands%20joined%20in%20prayer&width=600&height=500&seq=cfn-fellowship-1&orientation=landscape"
                alt="CFN Fellowship"
                className="rounded-lg shadow-2xl object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CFN Structure */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">CFN Structure</h2>
            <p className="text-xl text-gray-600">Organized for growth, discipleship, and multiplication</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-home-heart-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Local Centers</h3>
              <p className="text-gray-700 mb-4">
                Small groups meeting in homes, community centers, or rented spaces for weekly fellowship, 
                teaching, and prayer.
              </p>
              <ul className="text-left text-gray-600 space-y-2">
                <li>• Weekly teaching sessions</li>
                <li>• Prayer and worship</li>
                <li>• Fellowship meals</li>
                <li>• Discipleship training</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-building-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Regional Coordination</h3>
              <p className="text-gray-700 mb-4">
                Regional coordinators oversee multiple local centers, providing support, training, 
                and ensuring doctrinal consistency.
              </p>
              <ul className="text-left text-gray-600 space-y-2">
                <li>• Leadership training</li>
                <li>• Resource distribution</li>
                <li>• Monthly gatherings</li>
                <li>• Pastoral oversight</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-global-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Global Network</h3>
              <p className="text-gray-700 mb-4">
                International coordination through the PAAM headquarters, connecting all CFN centers 
                worldwide under apostolic oversight.
              </p>
              <ul className="text-left text-gray-600 space-y-2">
                <li>• Annual conventions</li>
                <li>• Global training programs</li>
                <li>• Resource sharing</li>
                <li>• Apostolic oversight</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* How to Join CFN */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">How to Join CFN</h2>
            <p className="text-xl text-gray-600">Three simple steps to become part of the global family</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">1</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Find a Local Center</h3>
              <p className="text-gray-700">
                Search for an existing CFN center in your area or express interest in starting 
                a new center in your community.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">2</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Complete GMTP</h3>
              <p className="text-gray-700">
                Participate in the 60-day Global Mandate Training Program to understand 
                PAAM doctrine and CFN principles.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">3</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Begin Fellowship</h3>
              <p className="text-gray-700">
                Start attending regular CFN meetings and become an active member of your 
                local Christ Family Network center.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CFN Benefits */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">CFN Benefits</h2>
            <p className="text-xl text-gray-600">What you gain as a CFN member</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <i className="ri-book-open-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Apostolic Teaching</h4>
              <p className="text-gray-600 text-sm">Regular access to sound doctrine and biblical training</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <i className="ri-group-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Spiritual Family</h4>
              <p className="text-gray-600 text-sm">Deep fellowship with like-minded believers</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <i className="ri-user-follow-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Mentorship</h4>
              <p className="text-gray-600 text-sm">Personal discipleship and spiritual guidance</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <i className="ri-seedling-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Ministry Opportunities</h4>
              <p className="text-gray-600 text-sm">Platforms to serve and develop your gifts</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <i className="ri-heart-pulse-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Prayer Support</h4>
              <p className="text-gray-600 text-sm">Intercessory prayer and spiritual covering</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <i className="ri-graduation-cap-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Training Resources</h4>
              <p className="text-gray-600 text-sm">Access to PAAM educational materials</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <i className="ri-calendar-event-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Global Events</h4>
              <p className="text-gray-600 text-sm">Participation in international conferences</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <i className="ri-shield-check-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Spiritual Covering</h4>
              <p className="text-gray-600 text-sm">Apostolic oversight and protection</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-[#b8144a] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Join the Family?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Become part of a global network of believers committed to apostolic truth, 
            spiritual growth, and Kingdom advancement.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-[#b8144a] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
              Find Local CFN Center
            </button>
            <button className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-[#b8144a] transition-colors whitespace-nowrap cursor-pointer">
              Start New Center
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
